import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { buildMatchLink, type MatchParams } from '../../utils/matchParams';
interface ArticleCTABandProps {
  body: string;
  buttonLabel: string;
  /** Compact variant sits inside the article body; full sits at the end. */
  variant?: 'inline' | 'full';
  /** Pre-populates the match widget with this article's context. */
  match?: MatchParams;
}
export function ArticleCTABand({
  body,
  buttonLabel,
  variant = 'full',
  match
}: ArticleCTABandProps) {
  const to = buildMatchLink('/request-information', match);
  if (variant === 'inline') {
    return <aside className="bg-light border border-gray-200 rounded-xl p-6 sm:p-7" data-id="element-115" data-mp="tiscq2lghkop">
        <p className="text-gray-700 leading-relaxed mb-5" data-id="element-116" data-mp="okqxjsr5i5ii">{body}</p>
        <Link to={to} className="inline-flex items-center gap-2 bg-cta hover:bg-cta-dark text-white font-bold py-3 px-7 rounded-lg text-sm transition-colors duration-200" data-id="element-117" data-mp="kicf39re97rr">
          {buttonLabel}
          <ArrowRightIcon className="w-4 h-4" aria-hidden="true" data-id="element-118" data-mp="1va2olr85i6rg" />
        </Link>
        <p className="mt-3 text-xs text-gray-500" data-id="element-119" data-mp="201uedzjhg8gj">
          Free for students. No obligation to enroll.
        </p>
      </aside>;
  }
  return <section className="bg-navy py-14" data-id="element-120" data-mp="1m838d14yn6pk">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-121" data-mp="1qaztayhz3ewo">
        <h2 className="text-3xl font-bold text-white mb-4" data-id="element-122" data-mp="2e1c88tbmybwr">
          Get Matched Free
        </h2>
        <p className="text-white/80 leading-relaxed mb-8" data-id="element-123" data-mp="2j0glbv1oktsd">{body}</p>
        <Link to={to} className="inline-flex items-center gap-2 bg-cta hover:bg-cta-dark text-white font-bold py-3.5 px-10 rounded-lg text-sm transition-colors duration-200" data-id="element-124" data-mp="2izni341xkmez">
          {buttonLabel}
          <ArrowRightIcon className="w-4 h-4" aria-hidden="true" data-id="element-125" data-mp="tliftxcr0okf" />
        </Link>
        <p className="mt-4 text-xs text-white/60" data-id="element-126" data-mp="tnlc2z4hvdxl">
          Matching is free for students. No obligation to enroll.
        </p>
      </div>
    </section>;
}